import React, { type FC } from 'react';

import { SimpleVideo, ABTest } from '@lucid/components-react';

import videoData from './videoData.json';

const ABTestLanderVideo: FC = () => (
  <ABTest branchesToRender={['T_A', 'T_B', 'T_C', 'T_D']} testName="FY24Q1_ChartBrandedAddVideoV2" trigger="visible">
    <ABTest.Branch as="span" branch="T_A" />
    <ABTest.Branch branch="T_B">
      <SimpleVideo {...videoData[0]} />
    </ABTest.Branch>
    <ABTest.Branch branch="T_C">
      <SimpleVideo {...videoData[1]} />
    </ABTest.Branch>
    <ABTest.Branch branch="T_D">
      <SimpleVideo {...videoData[2]} />
    </ABTest.Branch>
  </ABTest>
);

export default ABTestLanderVideo;
